import React from "react";

const FAQS = [
  {
    question: "Cost?",
    answer: "SMS charged at Ksh 2 per SMS. T&Cs apply.",
  },
  {
    question: "More than one child?",
    answer: "Yes. One SMS application per child.",
  },
  {
    question: "How will I know if selected?",
    answer: "SMS and school. Keep your line active.",
  },
];

function FaqList() {
  return (
    <dl className="mx-auto mt-6 w-full max-w-4xl space-y-2 rounded-xl border border-slate-200 bg-white/80 px-4 py-3 text-xs shadow-sm">
      {FAQS.map((item) => (
        <div
          key={item.question}
          className="flex flex-col gap-0.5 sm:flex-row sm:items-baseline sm:gap-2"
        >
          <dt className="font-semibold text-slate-700">{item.question}</dt>
          <dd className="text-slate-600">{item.answer}</dd>
        </div>
      ))}
    </dl>
  );
}

export default FaqList;
